module.exports = __webpack_public_path__ + "static/media/chart-54k-v2.5af71a91.svg";